import { useRecoilState } from 'recoil'

import { InquiryContent } from '@/shared/store'
import { TextAreaCustom, TextAreaFormWrap } from '@/styles/common/CommonForm/textareaform'

const TextAreaForm = (props: any) => {
  const { title } = props
  const [inquiryContent, setInquiryContent] = useRecoilState(InquiryContent)
  const onInputFunc = (e: any) => {
    if (e.target.value.length > 150) {
      e.target.value.length.slice(0, 150)
    } else {
      setInquiryContent(e.target.value)
    }
  }

  return (
    <TextAreaFormWrap>
      <div>
        <p>{title}</p>
        <span
          className={`${inquiryContent?.length > 9 ? 'complete' : inquiryContent.length === 0 ? 'default' : 'err'}`}
        >
          {inquiryContent?.length}/150
        </span>
      </div>
      <TextAreaCustom
        maxLength={150}
        placeholder="내용을 입력해주세요."
        onInput={onInputFunc}
        value={inquiryContent}
      />
    </TextAreaFormWrap>
  )
}
export default TextAreaForm
